// 011 FR-031: one order at /orders/<id>. Phones get the pushed screen's app bar.
import { useLocalSearchParams } from "expo-router";
import { View } from "react-native";

import { OrderDetailScreen } from "@/orders/OrderDetailScreen";
import { AppBar } from "@/shell/chrome/AppBar";
import { useChromeKind } from "@/shell/chrome/useChromeKind";

export default function OrderDetail() {
  const { orderId } = useLocalSearchParams<{ orderId: string }>();
  const mobile = useChromeKind() === "mobile";
  return (
    <View style={{ flex: 1 }}>
      {mobile ? <AppBar title="Order" fallbackHref="/orders" /> : null}
      <OrderDetailScreen key={orderId} orderId={orderId} />
    </View>
  );
}
